import { client } from '../client';

export interface ConfirmEmailUpdateResponse {
  success: boolean;
  message: string;
}

export const confirmEmailUpdate = async (token: string): Promise<ConfirmEmailUpdateResponse> => {
  const { data } = await client.get<ConfirmEmailUpdateResponse>(`/auth/email_update/confirm`, {
    params: { token },
  });

  return data;
};
